import axios from 'axios';
import moment from 'moment-timezone';

import { getSchedulingServerURL } from '../../HarverPages/shared/helper';

export enum TimeZoneName {
    SHORT = 'short',
    LONG = 'long',
}

function getTimeZone(date: Date, language: string, timeZoneName: TimeZoneName): string {
    const dateTimeFormatter = new Intl.DateTimeFormat(language, { timeZoneName });
    return dateTimeFormatter.formatToParts(date).find((part) => part.type === 'timeZoneName')!.value;
}

export function getTimezoneName(
    date: Date,
    locale: string,
): {
    short: string;
    long: string;
} {
    const language = locale.replace(/_/, '-');

    return {
        short: getTimeZone(date, language, TimeZoneName.SHORT),
        long: getTimeZone(date, language, TimeZoneName.LONG),
    };
}

function formatInterviewDateTime(startTimestamp: string, endTimestamp: string, locale: string) {
    const startTime = moment(startTimestamp);
    const endTime = moment(endTimestamp);

    return {
        date: startTime.format('dddd, DD MMMM'),
        duration: `${startTime.format('HH:mm')} - ${endTime.format('HH:mm')}`,
        timezoneName: getTimezoneName(new Date(startTimestamp), locale),
    };
}

export interface ConfirmationDetails {
    isCancelled?: boolean;
    interviewers: string[];
    location: string;
    candidateName: string;
    organizationName: string;
    startTime: string;
    endTime: string;
    date: string;
    duration: string;
    timezoneName: {
        short: string;
        long: string;
    };
    isRescheduleEnabled: boolean;
}

export async function getInterviewConfirmationDetails(
    calendarEventId: string,
    locale: string,
): Promise<ConfirmationDetails> {
    const { data: interview } = await axios.get(`${getSchedulingServerURL()}/interview/confirmation`, {
        params: { calendarEventId },
    });

    return {
        isCancelled: interview.isCancelled,
        organizationName: interview.organizationName,
        startTime: interview.startTime,
        endTime: interview.endTime,
        interviewers: interview.interviewers,
        location: interview.location || '',
        candidateName: interview.candidateName,
        ...formatInterviewDateTime(interview.startTime, interview.endTime, locale),
        isRescheduleEnabled: interview.isRescheduleEnabled,
    };
}
